import AxiosClient from "../../../services/axios.services";

class PeriodicityServices {
  getPeriodicity = (params) =>
    AxiosClient.get("/api/app/evaluacion_periodicidad/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getPeriodicityById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_periodicidad/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  savePeriodicity = (data) =>
    AxiosClient.post("/api/app/evaluacion_periodicidad/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editPeriodicity = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_periodicidad/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePeriodicity = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_periodicidad/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new PeriodicityServices();
